// extracted by mini-css-extract-plugin
module.exports = {"outerClass":"Cashflow_outerClass__2d8l4","header":"Cashflow_header__imFbo","headTag":"Cashflow_headTag__1K5tv","amtTag":"Cashflow_amtTag__2XQuL","center":"Cashflow_center__Pge1I"};